var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',[_c('van-sticky',[_c('van-nav-bar',{attrs:{"title":"洽谈室","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('chat-ting-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }